import { useTranslation } from 'react-i18next';
import ReactMarkdown from 'react-markdown';

import { Box, Paper, Typography } from '@mui/material';

import { stylesPrivacyStatementPaper } from './PrivacyStatement.styles';

export function PrivacyStatement() {
  const { t } = useTranslation('customsPass_privacyStatementPage');

  return (
    <>
      <Typography variant='h1' mb={3}>
        {t('privacyStatement.title')}
      </Typography>
      <Paper sx={stylesPrivacyStatementPaper}>
        <Typography variant='h2' mb={2}>
          {t('privacyStatement.commitmentToPersonalData.title')}
        </Typography>
        <Typography variant='bodyMD' mb={3} component='p'>
          <ReactMarkdown>{t('privacyStatement.commitmentToPersonalData.content')}</ReactMarkdown>
        </Typography>
        <Typography variant='h2' mb={2}>
          {t('privacyStatement.privacyStatement.title')}
        </Typography>
        <Typography variant='bodyMD' component='p' fontWeight='fontWeightSemiBold' mb={2}>
          {t('privacyStatement.privacyStatement.date')}
        </Typography>
        <Typography variant='bodyMD' component='div' fontWeight='fontWeightSemiBold' mb={2}>
          {t('privacyStatement.signifyingOfPrivacyStatement.title')}
        </Typography>
        <Typography variant='bodyMD' component='p' mb={3}>
          <ReactMarkdown>{t('privacyStatement.signifyingOfPrivacyStatement.content')}</ReactMarkdown>
        </Typography>
        <Typography variant='bodyMD' component='p' fontWeight='fontWeightSemiBold' mb={2}>
          {t('privacyStatement.whatPersonalDataSherpassCollect.title')}
        </Typography>
        <Typography variant='bodyMD' component='p' mb={3}>
          {t('privacyStatement.whatPersonalDataSherpassCollect.content')}
        </Typography>
        <Typography variant='bodyMD' component='p' mb={3}>
          <ReactMarkdown>{t('privacyStatement.whatPersonalDataSherpassCollect.content.detail')}</ReactMarkdown>
        </Typography>
        <Typography variant='bodyMD' component='p' fontWeight='fontWeightSemiBold' mb={2}>
          {t('privacyStatement.howSherpassUsePersonalData.title')}
        </Typography>
        <Typography variant='bodyMD' component='p' mb={3}>
          {t('privacyStatement.howSherpassUsePersonalData.content.detail')}
        </Typography>
        <Box component='ul' sx={{ listStyleType: 'disc' }}>
          <Typography variant='bodyMD' component='li' fontWeight='fontWeightSemiBold' mb={2}>
            {t('privacyStatement.howSherpassUsePersonalData.content.detail.item1')}
          </Typography>
          <Box component='ul'>
            <Typography component='li' variant='bodyMD'>
              {t('privacyStatement.howSherpassUsePersonalData.content.detail.item1.child1')}
            </Typography>
            <Typography component='li' variant='bodyMD'>
              {t('privacyStatement.howSherpassUsePersonalData.content.detail.item1.child2')}
            </Typography>
          </Box>
          <Typography variant='bodyMD' component='li' fontWeight='fontWeightSemiBold' mb={2}>
            {t('privacyStatement.howSherpassUsePersonalData.content.detail.item2')}
          </Typography>
          <Box component='ul'>
            <Typography component='li' variant='bodyMD'>
              {t('privacyStatement.howSherpassUsePersonalData.content.detail.item2.child1')}
            </Typography>
            <Typography component='li' variant='bodyMD'>
              {t('privacyStatement.howSherpassUsePersonalData.content.detail.item2.child2')}
            </Typography>
            <Typography component='li' variant='bodyMD'>
              {t('privacyStatement.howSherpassUsePersonalData.content.detail.item2.child3')}
            </Typography>
            <Typography component='li' variant='bodyMD'>
              {t('privacyStatement.howSherpassUsePersonalData.content.detail.item2.child4')}
            </Typography>
            <Typography component='li' variant='bodyMD'>
              {t('privacyStatement.howSherpassUsePersonalData.content.detail.item2.child5')}
            </Typography>
            <Typography component='li' variant='bodyMD'>
              {t('privacyStatement.howSherpassUsePersonalData.content.detail.item2.child6')}
            </Typography>
          </Box>
        </Box>
        <Box component='ul' sx={{ listStyleType: 'disc' }}>
          <Typography variant='bodyMD' component='li' fontWeight='fontWeightSemiBold' mb={2}>
            {t('privacyStatement.howSherpassUsePersonalData.content.detail.item3')}
          </Typography>
          <Box component='ul'>
            <Typography component='li' variant='bodyMD'>
              {t('privacyStatement.howSherpassUsePersonalData.content.detail.item3.child1')}
            </Typography>
            <Typography component='li' variant='bodyMD'>
              {t('privacyStatement.howSherpassUsePersonalData.content.detail.item3.child2')}
            </Typography>
          </Box>
        </Box>
        <Box component='ul' sx={{ listStyleType: 'disc' }}>
          <Typography variant='bodyMD' component='li' fontWeight='fontWeightSemiBold' mb={2}>
            {t('privacyStatement.howSherpassUsePersonalData.content.detail.item4')}
          </Typography>
          <Box component='ul'>
            <Typography component='li' variant='bodyMD'>
              {t('privacyStatement.howSherpassUsePersonalData.content.detail.item4.child1')}
            </Typography>
            <Typography component='li' variant='bodyMD'>
              {t('privacyStatement.howSherpassUsePersonalData.content.detail.item4.child2')}
            </Typography>
          </Box>
        </Box>
        <Typography variant='bodyMD' component='p' fontWeight='fontWeightSemiBold' mb={2}>
          {t('privacyStatement.howSherpassJustifyLegitimateInterests.title')}
        </Typography>
        <Typography variant='bodyMD' component='p' mb={3}>
          <ReactMarkdown>{t('privacyStatement.howSherpassJustifyLegitimateInterests.content')}</ReactMarkdown>
        </Typography>
        <Typography variant='bodyMD' component='p' fontWeight='fontWeightSemiBold' mb={2}>
          {t('privacyStatement.howLongSherpassKeepPersonalData.title')}
        </Typography>
        <Typography variant='bodyMD' component='p' mb={3}>
          <ReactMarkdown>{t('privacyStatement.howLongSherpassKeepPersonalData.content')}</ReactMarkdown>
        </Typography>
        <Typography variant='bodyMD' component='p' fontWeight='fontWeightSemiBold' mb={2}>
          {t('privacyStatement.howSherpassSharePersonalData.title')}
        </Typography>
        <Typography variant='bodyMD' component='p' mb={3}>
          <ReactMarkdown>{t('privacyStatement.howSherpassSharePersonalData.content')}</ReactMarkdown>
        </Typography>
        <Typography variant='bodyMD' component='p' fontWeight='fontWeightSemiBold' mb={2}>
          {t('privacyStatement.whatAreYourChoicesAndRights.title')}
        </Typography>
        <Typography variant='bodyMD' component='p' mb={3}>
          <ReactMarkdown>{t('privacyStatement.whatAreYourChoicesAndRights.content')}</ReactMarkdown>
        </Typography>
        <Typography variant='bodyMD' component='p' fontWeight='fontWeightSemiBold' mb={2}>
          {t('privacyStatement.updateOfStatement.title')}
        </Typography>
        <Typography variant='bodyMD' component='p' mb={3}>
          {t('privacyStatement.updateOfStatement.detail.item1')}
        </Typography>
        <Typography variant='bodyMD' component='p' fontWeight='fontWeightSemiBold' mb={2}>
          {t('privacyStatement.contactUs.title')}
        </Typography>
        <Typography variant='bodyMD' component='p' mb={3}>
          <ReactMarkdown>{t('privacyStatement.contactUs.content')}</ReactMarkdown>
        </Typography>
      </Paper>
    </>
  );
}
